/* External */
import mapValues from 'lodash-es/mapValues';

/* Utils */
import {
  Content,
} from '../models';

import { isEpisode } from '../../utils/metaDataUtils';

export function deleteTitleFromContentContinueWatching(
  entities,
  isFromGetContinueWatchingShow = false,
) {
  const newEntities = entities;
  const contents = entities[Content.entityName];
  if (contents && (entities?.carousels?.UCTAContinueWatching || isFromGetContinueWatchingShow)) {
    newEntities[Content.entityName] = mapValues(
      contents,
      (content) => {
        if (isEpisode(content) && content.title) {
          return {
            ...content,
            title: undefined,
            episode: {
              ...content?.episode,
              showName: content?.episode?.showName || content.title,
            },
          };
        }
        return content;
      },
    );
  }
  return newEntities;
}

export function removeDurationAndProgressFromContentCarousel(entities) {
  const newEntities = entities;
  const contents = entities[Content.entityName];

  if (contents) {
    newEntities[Content.entityName] = mapValues(contents, (content) => {
      if (content.duration || content.progress.toString()) {
        return {
          ...content,
          duration: undefined,
          progress: undefined,
        };
      }
      return content;
    });
  }

  return newEntities;
}

export function addShowAttributesToContents(entities, showAttributes) {
  const newEntities = entities;
  const vodContents = entities[Content.entityName];
  const { showId, showName } = showAttributes;

  if (vodContents && (showId || showName)) {
    newEntities[Content.entityName] = mapValues(
      vodContents,
      (content) => ({
        ...content,
        episode: {
          showName,
          showId,
          ...content.episode,
        },
      }),
    );
  }

  return newEntities;
}
